const INITIAL_STATE = {
    supplierList: [],
};

export default function supplierReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'SET_SUPPLIER_LIST':
            return {
                ...state,
                supplierList: action.list,
            };
        default:
            return state;
    }
}
